import TranslatorClient from '../shared/TranslatorClient';
import request from '../../request';
import { URL, PARAM } from '../../../constants/reading/ApiConstants';

const { D8_FORM_URL, D8_INTERPS_URL, D8_TRANSLATOR_RESULTS_URL } = URL;
const { DISTRICT_UID, DYSLEXIA, OBSERVATIONS, WITH_ZOG, WITH_LEXILES, WITH_PERCENTILES } = PARAM;

class ReadingTranslatorClient extends TranslatorClient {
    static getResults = (studentIds, districtId, additionalParams = {}) =>
        super.getResults(D8_TRANSLATOR_RESULTS_URL, studentIds, {
            [DYSLEXIA]: true,
            [OBSERVATIONS]: true,
            [WITH_ZOG]: true,
            [WITH_PERCENTILES]: true,
            [DISTRICT_UID]: districtId,
            [WITH_LEXILES]: true,
            ...additionalParams,
        });

    static getForm = formId => request.get(`${D8_FORM_URL}/${formId}`);

    static getInterps = () => request.get(D8_INTERPS_URL);
}

export default ReadingTranslatorClient;
